"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var DownloadCloud = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_DownloadCloud_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 18,
    height: 15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.446 4.402a.146.146 0 0 1-.12.11 2.772 2.772 0 0 0 .423 5.509h3.24A.51.51 0 0 0 5.99 9H2.75a1.75 1.75 0 0 1-.268-3.48c.465-.07.842-.414.956-.87a3.502 3.502 0 0 1 5.815-1.68c.306.293.746.397 1.15.273a1.751 1.751 0 0 1 2.236 1.351c.087.476.459.847.934.935A1.75 1.75 0 0 1 13.25 9h-3.24a.51.51 0 0 0 0 1.02h3.24a2.77 2.77 0 0 0 .508-5.494.146.146 0 0 1-.117-.117 2.772 2.772 0 0 0-3.539-2.142.146.146 0 0 1-.144-.034 4.523 4.523 0 0 0-7.512 2.169Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.854 11.647a.5.5 0 1 0-.708.706l2.488 2.5A.498.498 0 0 0 7.99 15a.498.498 0 0 0 .364-.146l2.5-2.5a.5.5 0 0 0-.707-.708L8.5 13.293V7.5a.5.5 0 0 0-1 0v5.8l-1.646-1.653Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_DownloadCloud_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = DownloadCloud;
exports["default"] = _default;